import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useCollection } from 'Context/CollectionContext';
import { Box } from '@material-ui/core';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import { AddCircle } from '@material-ui/icons';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import { darken } from '@material-ui/core/styles/colorManipulator';
import classNames from 'classnames';
import Card from 'Components/ComponentLibrary/Molecules/Card';

const CardList = withStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  list: {
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
    flex: '1 1 auto',
    flexWrap: 'wrap',
  },
  listItem: {
    backgroundColor: darken(theme.palette.facet.lightGray5, 0.1),
    flexGrow: 1,
  },
  complete: {
    backgroundColor: theme.palette.facet.accentBlue20,
    '&:hover': {
      backgroundColor: darken(theme.palette.facet.accentBlue20, 0.1),
    },
  },
}))((props) => {
  const {
    label, onClick, renderPrimary, classes, addLabel, onAdd, ...rest
  } = props;
  const { collection } = useCollection();

  return (
    <Box className={classes.root} {...rest}>
      <Box className={classes.header}>
        <Typography component="p">
          {label}
        </Typography>
        {onAdd && (
          <Button
            size="small"
            startIcon={<AddCircle color="secondary" />}
            onClick={onAdd}
          >
            {addLabel}
          </Button>
        )}
      </Box>
      <Box className={classes.list}>
        {collection?.resources().list().map((r) => (
          <Card
            key={r.id()}
            className={classNames(classes.listItem, {
              [classes.complete]: r.id(),
            })}
            resource={r}
            complete={r.id()}
            onClick={() => onClick(r)}
            primaryText={renderPrimary(r)}
          />
        )) || <Skeleton className={classes.listItem} height={64} />}
      </Box>
    </Box>
  );
});


CardList.defaultProps = {
  addLabel: 'New',
  onAdd: false,
};

CardList.propTypes = {
  classes: PropTypes.object.isRequired,
  renderPrimary: PropTypes.func,
  onClick: PropTypes.func,
  onAdd: PropTypes.oneOf([PropTypes.func, PropTypes.bool]),
  addLabel: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default CardList;
